import { isEmpty } from 'lodash'
import * as Yup from 'yup'

const schemaTypes = {
  string: Yup.string,
  number: Yup.number,
  boolean: Yup.boolean,
  date: Yup.date,
  array: Yup.array,
  object: Yup.object,
}

const validationRules = {
  required: (schema, validation) =>
    schema.required(validation.message || 'Este campo es obligatorio'),
  min: (schema, validation) =>
    schema.min(
      validation.value,
      validation.message || `Debe ser al menos ${validation.value}`
    ),
  max: (schema, validation) =>
    schema.max(
      validation.value,
      validation.message || `Debe ser como máximo ${validation.value}`
    ),
  length: (schema, validation) =>
    schema.length(
      validation.value,
      validation.message ||
        `Debe tener exactamente ${validation.value} caracteres`
    ),
  email: (schema) => schema.email('Correo inválido'),
  url: (schema) => schema.url('URL inválida'),
  matches: (schema, validation) =>
    schema.matches(
      new RegExp(validation.value),
      validation.message || 'Formato inválido'
    ),
  oneOf: (schema, validation) =>
    schema.oneOf(
      validation.value,
      validation.message || `Debe ser uno de: ${validation.value.join(', ')}`
    ),
  notOneOf: (schema, validation) =>
    schema.notOneOf(
      validation.value,
      validation.message ||
        `No puede ser uno de: ${validation.value.join(', ')}`
    ),
  positive: (schema) => schema.positive('Debe ser un número positivo'),
  negative: (schema) => schema.negative('Debe ser un número negativo'),
  integer: (schema) => schema.integer('Debe ser un número entero'),
  lessThan: (schema, validation) =>
    schema.lessThan(
      validation.value,
      validation.message || `Debe ser menor que ${validation.value}`
    ),
  moreThan: (schema, validation) =>
    schema.moreThan(
      validation.value,
      validation.message || `Debe ser mayor que ${validation.value}`
    ),
  test: (schema, validation) =>
    schema.test(validation.name, validation.message, validation.callback),
}

export const GenerateYupValidator = ({ fields }) => {
  return (
    fields &&
    fields.length > 0 &&
    Yup.object().shape(
      fields.reduce((acc, field) => {
        const fieldType = schemaTypes[field.type] || Yup.string
        let schema = fieldType()

        if (field.validations && field.validations.length > 0) {
          field.validations.map((validation) => {
            const applyRule = validationRules[validation.type]
            if (applyRule) {
              schema = applyRule(schema, validation)
            }
          })
        }

        //validate conditional is if field not empty
        const isFieldEmpty = isEmpty(field.conditional)

        if (field.conditional && !isFieldEmpty) {
          schema = schema.when(
            field.conditional.field,
            (fieldValue, schemaWhen) => {
              if (
                Array.isArray(field.conditional.values) &&
                field.conditional.values.includes(fieldValue)
              ) {
                return field.conditional.validations.reduce(
                  (s, v) => validationRules[v.type](s, v),
                  schemaWhen
                )
              }
              return schemaWhen
            }
          )
        }

        acc[field.name] = schema
        return acc
      }, {})
    )
  )
}
